import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const CardBodyListItem = withConfig(theme => styled('li', { label: 'CardBodyListItem' })`
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
    display: flex;
    flex-flow: row nowrap;
    height: 48px;
    justify-content: space-between;
`);

